<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <span class="current">{{ $route.query.title }}</span>
    </div>
    <SearchKeyWords></SearchKeyWords>
    <div :class="{ 'classify-course': course_id }">
      <Classify
        class="classify"
        :class="{
          'classify-top': !$route.query.recommend && !$route.query.keywords,
        }"
        :items="classifyItems"
        @change="onClassifyChange"
      ></Classify>
      <div v-if="course_id" class="package-course" @click="onClearCourse">
        <span>{{ $route.query.course_name }}</span>
        <i class="el-icon-close package-course_close"></i>
      </div>
    </div>
    <ListSort v-model="sort"></ListSort>
    <List
      class="list"
      ref="list"
      url="/api/app/packageCourse"
      :search="search"
      :limit="16"
      :alwaysShowPager="true"
    >
      <template v-slot="{ list }">
        <div class="clearfix" v-if="list.length">
          <PackageItem
            v-for="item in list"
            :key="item.id"
            :item="item"
          ></PackageItem>
        </div>
        <EmptyNew v-if="list.length == 0" class="empty" title="暂无课程包！" />
      </template>
    </List>
  </div>
</template>
<script>
import List from "@/components/List.vue";
import PackageItem from "@/modules/stu/components/package/PackageItem.vue";
import Classify from "@/modules/stu/components/Classify.vue";
import ListSort from "@/modules/stu/components/ListSort.vue";
import SearchKeyWords from "@/modules/stu/components/SearchKeyWords.vue";
import EmptyNew from "@/components/EmptyNew.vue";

export default {
  name: "Package",
  components: {
    List,
    PackageItem,
    Classify,
    ListSort,
    SearchKeyWords,
    EmptyNew,
  },
  data() {
    return {
      classifyList: [],
      subClassify: 0,
      course_id: this.$route.query.course_id,
      sort: 0,
      classify_id: 0,
    };
  },
  computed: {
    search() {
      return {
        classify_id: this.subClassify || this.classify_id,
        order_by: this.sort,
        recommend: this.$route.query.recommend,
        course_id: this.course_id,
        keywords: this.$route.query.keywords,
      };
    },

    classifyItems() {
      let items = [];
      items.push({
        id: "classify_id",
        name: "课程分类",
        value: { item: this.classify_id, child: this.subClassify },
        children: this.classifyList,
      });

      return items;
    },

  },
  watch: {
    $route() {
      this.$refs.list.searchRefresh();
    },
    sort() {
      this.$refs.list.searchRefresh();
    },
  },
  async created() {
    await this.getClassify();
  },
  methods: {
    async getClassify() {
      let params = {};
      if (this.$route.query.recommend) {
        params.recommend = this.$route.query.recommend;
      }
      let data = await this.$http.get( "/api/app/packageCourseClassify/index", params);
      data.classify.unshift({ id: 0, name: "全部" });
      data.classify.forEach(c => {
        if (!c.children) {
          return;
        }
        c.children.unshift({ id: 0, name: "全部" });
      });
      this.classifyList = data.classify;
    },
    onClassifyChange({ id, value }) {
      this[id] = value.item;
   
      this.subClassify = value.child;
      this.$refs.list.searchRefresh();
    },
    onClearCourse() {
      this.course_id = "";
      this.$refs.list.searchRefresh();
    },
  },
};
</script>


<style lang="scss" scoped>
.classify {
  /deep/ {
    .type {
      display: none;
    }
    #sign_type_1 {
      margin-right: 36px;
    }
  }
}
.classify-top {
  margin-top: 24px;
}
.select-tab-wrap {
  margin-top: 30px;
}
.list {
  /deep/ {
    .pager {
      margin-top: 10px !important;
    }
  }
}
.main-container {
  padding-bottom: 46px;
}
.empty {
  margin-bottom: 50px;
}
.package-course {
  font-size: 14px;
  background: #e6e6e6;
  display: inline-block;
  color: #333333;
  padding: 4px 11px;
  border-radius: 5px;
  margin: 0 0 0 20px;
  position: relative;
  top: -8px;
}
.package-course_close {
  color: #808080;
  margin-left: 14px;
  font-weight: bold;
  cursor: pointer;
}
.classify-course {
  background: white;
  padding-bottom: 6px;
  border-radius: 5px;
  .classify {
    border-radius: 5px 5px 0 0;
  }
}
</style>
